import React, { useState, useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { IconArrowUp } from "@tabler/icons-react";

const ScrollButton = styled.button`
  ${tw`fixed p-4 rounded-full shadow-2xl z-40 transition-all duration-300`}
  bottom: 2rem;
  right: 2rem;
  background: var(--primary-color);
  color: white;
  border: none;
  cursor: pointer;
  opacity: ${(props) => (props.visible ? "1" : "0")};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  transform: ${(props) =>
    props.visible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.8)"};

  &:hover {
    background: #9f6e33;
    transform: translateY(-5px) scale(1.1);
    box-shadow: 0 15px 35px rgba(199, 138, 65, 0.4);
  }

  &:active {
    transform: translateY(-2px) scale(1.05);
  }

  @media (max-width: 640px) {
    ${tw`p-3`}
    bottom: 1.5rem;
    right: 1.5rem;
  }
`;

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      setVisible(scrolled > 300);
    };

    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <ScrollButton
      visible={visible}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <IconArrowUp size={24} />
    </ScrollButton>
  );
};

export default ScrollToTop;
